module.exports = __webpack_public_path__ + "static/media/gust.a9d9e629.svg";